// @ts-strict-ignore
import {Injectable} from "@angular/core";
import {CameraLayoutMap, Modules, Scope, WebSettings} from "@models";
import {SimSystemExtendedService} from "./sim-service-system.service";
import Enumerable from "linq";
import {Subject} from "rxjs";

/**
 * ConfigurationService
 */
@Injectable({
	providedIn: "root",
})
export class SimConfigurationService {
	private static _settings: WebSettings = null;
	public static get settings() {
		return SimConfigurationService._settings;
	}

	constructor(private readonly _simSystemService: SimSystemExtendedService) {}

	public static readonly configChanged = new Subject<void>();

	public static hasLicenseModule(module: Modules) {
		return SimConfigurationService._settings.license.enabledModules.includes(module);
	}

	public static isScope(scopeElement: Scope) {
		return SimConfigurationService._settings.license.scope === scopeElement;
	}

	/**
	 * Reloads Config from config file
	 */
	public reloadConfig() {
		return new Promise<boolean>((resolve) => {
			this._simSystemService
				.getSettings()
				.then((response) => {
					SimConfigurationService._settings = response;

					resolve(true);
				})
				.catch((response) => {
					// TODO: this is a critical error - no settings means software will have undefined behaviour
					console.error(`Settings could not be loaded!`);

					SimConfigurationService._settings = <WebSettings>{};

					resolve(false);
				})
				.finally(() => {
					this.handleSettingsDependencies();
					SimConfigurationService.configChanged.next();
				});
		});
	}

	private handleSettingsDependencies() {
		Enumerable.from(CameraLayoutMap.entries()).forEach((x) => {
			x[1].enabled = !SimConfigurationService.settings.disabledRoomLayouts.includes(x[0]);
		});
	}
}
